/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.25.1
 * @since 1.0.0
 */
import produce from 'immer';
import { Reducer } from 'redux';

import {
    LOAD_STORAGE_DATA_FINISH,
    LOAD_STORAGE_DATA_START,
    REMOVE_STORAGE_DATA_START,
    REMOVE_STORAGE_DATA_SUCCESS,
    SET_COOKIE_DATA,
    SET_LOCAL_STORAGE_DATA,
    SET_STORAGE_DATA_SUCCESS,
} from './storageConstants';
import { ECookieKey, ELocalStorageKeys, ICookies, TStorageActionTypes } from './storageTypes';

export interface ILocalStorage {
    [key: string]: any;
}

export interface ISessionStorage {
    [timers: string]: ISessionStorageTimers[] | [];
}

export interface ISessionStorageTimers {
    buttonName: string;
    time: string | number;
}

export interface IStorageReducerState {
    cookies: ICookies;
    localStorage: ILocalStorage;
    sessionStorage: ISessionStorage;
}

export const initialStorageState: IStorageReducerState = {
    cookies: {
        [ECookieKey.BANNER_ALTERNATIVE_CLOSED]: '',
        [ECookieKey.BANNER_ALTERNATIVE_SHOWED]: '',
        [ECookieKey.BILL_PAGE]: '',
        [ECookieKey.CACHE_IN_PROGRESS]: '',
        [ECookieKey.EXPENSE_ANALYZER_PAGE]: '',
        [ECookieKey.DENSITY_LIST_VIEW]: true,
        [ECookieKey.JSESSIONID]: '',
        [ECookieKey.VOTING_HIDE]: '',
        [ECookieKey.XSRF_TOKEN]: '',
    },
    localStorage: {
        [ELocalStorageKeys.DASHBOARD_SELECTED_ACCOUNT]: '',
        [ELocalStorageKeys.CURRENT_USER_ID]: '',
        [ELocalStorageKeys.PRODUCTS]: '',
        [ELocalStorageKeys.SETTINGS_PROFILE_PARAMS]: '',
        [ELocalStorageKeys.TABLE_BTN_ACTIVE]: '',
        [ELocalStorageKeys.IS_SUBSCRIBERS_IN_ROAMING_PLATE_HIDDEN]: false,
        [ELocalStorageKeys.PRESELECTED_PRODUCT_CATEGORY]: '',
    },
    sessionStorage: {
        timers: [],
    },
};

/**
 * Storage module reducer
 * @param {IStorageReducerState} state
 * @param {IStorageActionTypes} action
 * @returns {Produced<IStorageReducerState, void>}
 */
const storageReducer: Reducer<IStorageReducerState, TStorageActionTypes> = (
    state: IStorageReducerState = initialStorageState,
    action: TStorageActionTypes,
) =>
    produce(state, (draft) => {
        switch (action.type) {
            case LOAD_STORAGE_DATA_START:
                break;
            case LOAD_STORAGE_DATA_FINISH:
                draft.cookies = { ...draft.cookies, ...action.payload.cookies };
                draft.localStorage = { ...draft.localStorage, ...action.payload.localStorage };
                draft.sessionStorage = { ...draft.sessionStorage, ...action.payload.sessionStorage };
                break;
            case REMOVE_STORAGE_DATA_START:
                break;
            case REMOVE_STORAGE_DATA_SUCCESS:
                draft.cookies.JSESSIONID = '';
                break;
            case SET_COOKIE_DATA:
                draft.cookies = { ...draft.cookies, [action.payload.key]: action.payload.value };
                break;
            case SET_LOCAL_STORAGE_DATA:
                draft.localStorage = { ...draft.localStorage, ...{ [action.payload.key]: action.payload.value } };
                break;
            case SET_STORAGE_DATA_SUCCESS:
                break;
            default:
                break;
        }
    });

export default storageReducer;
